import { useContext } from 'react';
import { ClientRequestFormContext } from '~/src/context/client-request-form/client-request-form.context';

export const useClientRequestForm = () => {
    const context = useContext(ClientRequestFormContext);
    if (!context) {
        throw new Error('useClientRequestFormContext необходимо использовать внутри ClientRequestFormProvider');
    }

    const handleTextChange = (path: string, value: string) => {
        context.dispatch({
            type: 'UPDATE_FIELD',
            payload: {
                variant: context.state.currentVariant,
                path,
                value,
            },
        });
    };

    const getTextValue = (path: string): string => {
        const variant = context.state.currentVariant;
        const keys = path.split('.');
        let value: unknown = context.state.variants[variant];

        for (const key of keys) {
            if (typeof value !== 'object' && value === null) {
                return '';
            }
            value = (value as Record<string, number | string>)[key];
        }

        return typeof value === 'string' ? value : '';
    };

    const clearField = (path: string) => {
        context.dispatch({
            type: 'CLEAR_FIELD',
            payload: {
                path,
            },
        });
    };

    const resetForm = () => {
        context.dispatch({ type: 'RESET_FORM' });
    };

    const setFieldError = (field: string, message: string) => {
        context.dispatch({
            type: 'SET_FIELD_ERROR',
            payload: { field, message },
        });
    };

    const clearFieldError = (field: string) => {
        context.dispatch({
            type: 'CLEAR_FIELD_ERROR',
            payload: { field },
        });
    };

    const getFieldError = (field: string): string => context.state.fieldErrors[field] || '';

    return {
        ...context,
        handleTextChange,
        getTextValue,
        clearField,
        resetForm,
        setFieldError,
        clearFieldError,
        getFieldError,
    };
};
